var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-10"},[_c('stories-section'),_c('v-divider',{staticClass:"my-14",attrs:{"color":"#0197bf"}}),_c('feed-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }